var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-scroll',[_c('div',{staticClass:"page-header"},[_c('h1',[_vm._v("Create Filler Article")])]),_vm._v(" "),(_vm.filler_article)?_c('single',{staticStyle:{"max-width":"800px"},attrs:{"filler-article":_vm.filler_article}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }